import React, { useEffect } from 'react';
import { CollectionPath } from '@typings/collections.enum';
import { useCollection, useDocument } from '@nandorojo/swr-firestore';
import { IstoreCommon } from '@typings/store/storeCommon.interface';
import { Ihashtag } from '@typings/common/hashtag.interface';
import useWindowWidth from '@hooks/useWindowWidth';
import DefaultLayout from './layout/DefaultLayout';
import FullPageLayout from './layout/FullPageLayout';
import { useGameUiNavVisible } from '@hooks/useGameUiNavVisible';
import showNav from '@utils/showNav';

type Props = {};
function StorePage({ }: Props) {
  // 페이지 진입/이탈 시 Game UI 가시성 제어
  useGameUiNavVisible(false);

  const windowWidth = useWindowWidth();
  const isMobile = windowWidth <= 480;

  const setCollectionPath = `${CollectionPath.NPC}`;
  const docId = 'storeSetting';
  const { data: setData } = useDocument<IstoreCommon>(
    `${setCollectionPath}/${docId}`,
    { listen: true },
  );

  const storeLayoutType = setData?.layoutType || 'default';

  // 해시태그 목록 가져오기
  const { data: hashtagList } = useCollection<Ihashtag>(
    `${CollectionPath.STORE}Hashtag`,
    { listen: true, orderBy: ['order', 'asc'] },
  );

  // 표시할 해시태그 필터링 (숨김 처리된 태그 제외)
  const visibleHashtagList = React.useMemo(() => {
    if (!hashtagList) return [];
    return hashtagList.filter((tag) => tag.isShow !== false);
  }, [hashtagList]);

  // 기본형 레이아웃
  if (storeLayoutType === 'default') {
    return (
      <DefaultLayout
        setData={setData}
        visibleHashtagList={visibleHashtagList}
      />
    );
  }

  // 풀페이지형 레이아웃
  return (
    <FullPageLayout
      setData={setData}
      visibleHashtagList={visibleHashtagList}
      isMobile={isMobile}
      windowWidth={windowWidth}
    />
  );
}

export default StorePage;
